import type { ConfigProviderThemeVars } from 'wot-design-uni';
import { isEmpty } from 'lodash-es';
import { defineStore } from 'pinia';
import { getProjectConfig } from '@/project';

export interface ThemeState {
  theme: 'dark' | 'light' // 主题，深色/浅色
  themeVars: ConfigProviderThemeVars // 主题内容配置
}

export const useThemeStore = defineStore({
  id: 'theme',
  state: (): ThemeState => ({
    theme: 'light',
    themeVars: {},
  }),
  getters: {
    initialTheme(): ConfigProviderThemeVars {
      const env = import.meta.env;
      const projectConfig = getProjectConfig(env);
      console.log('=========== initialTheme', projectConfig.mainColor);
      return {
        colorTheme: projectConfig.mainColor,
      };
    },
  },
  actions: {
    /* 初始化主题 */
    initTheme() {
      // 当前设置的主题为空，或与项目配置不同时，使用项目配置主题
      if (isEmpty(this.themeVars) || this.themeVars.colorTheme !== this.initialTheme.colorTheme) {
        this.themeVars = { ...this.initialTheme };
      }
      console.log('themeVars', this.themeVars);
    },
    /* 设置主题 */
    setTheme(newTheme?: 'dark' | 'light') {
      this.theme = newTheme || (this.theme === 'light' ? 'dark' : 'light');
    },
    /* 设置主题色 */
    setThemeVars(newThemeVars: ConfigProviderThemeVars) {
      this.themeVars = newThemeVars;
    },
  },
  persist: true,
});
